import React, { useEffect, useRef, useState } from 'react';
import {
    Box,
    Card,
    CardMedia,
    Container,
    Grid2,
    Grow,
    Fade,
    Typography,
} from '@mui/material';
import Button2 from '../../atoms/button2/button2';
import * as styles from './cardsConocer.module.scss';
import useScreenSize from '../../../hooks/useScreenSize';

export interface ICardsConocerProps {
    title?: string;
    description?: any;
    cardsList: [
        {
            image: string;
            title: string;
            description: any;
            redirect: string;
            btnTitle: string;
            imgPosition: string;
        },
    ];
}

const cardsConocer = ({
    title,
    description,
    cardsList,
}: ICardsConocerProps) => {
    const [isVisible, setIsVisible] = useState(false);
    const screenSize = useScreenSize();
    const elemRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setIsVisible(entries[0].isIntersecting);
            }
        });
        if (elemRef.current) {
            observer.observe(elemRef.current);
        }
        return () => observer.disconnect();
    }, []);

    return (
        <Container component="section" className={styles.o_cards_conocer}>
            <Grow in={isVisible} timeout={1500}>
                <Box className={styles.o_cards_conocer__intro}>
                    {title && (
                        <Typography
                            className={styles.o_cards_conocer__h2}
                            variant="h2"
                        >
                            {title}
                        </Typography>
                    )}
                    {description && (
                        <Typography
                            className={styles.o_cards_conocer__body}
                            variant="body1"
                        >
                            {description}
                        </Typography>
                    )}
                </Box>
            </Grow>
            <Fade in={isVisible} timeout={1500}>
                <div ref={elemRef}>
                    {cardsList.map((card, key) => (
                        <Card
                            key={key}
                            className={styles.o_cards_conocer__card}
                        >
                            <Grid2
                                container
                                spacing={2}
                                className={styles.o_cards_conocer__container}
                                style={{ flexDirection: screenSize > 968 ? (card.imgPosition === 'Left' ? 'row-reverse' : 'row') : 'column-reverse'}}
                                columnSpacing={4}
                            >
                                <Grid2
                                    size={{ xs: 12, md: 6 }}
                                    className={styles.o_cards_conocer__info}
                                    style={{ justifyContent: screenSize > 968 ? (card.imgPosition === 'Left' ? 'flex-start' : 'flex-end') : 'center'}}
                                >
                                    <div
                                        className={styles.o_cards_conocer__cta}
                                    >
                                        <Typography
                                            variant="h2"
                                            dangerouslySetInnerHTML={{
                                                __html: card.title,
                                            }}
                                            className={
                                                styles.o_cards_conocer__title
                                            }
                                        />
                                        <p
                                            className={
                                                styles.o_cards_conocer__desc
                                            }
                                        >
                                            {card.description}
                                        </p>
                                        {card.redirect && (
                                            <div
                                                className={
                                                    styles.o_cards_conocer__actions
                                                }
                                            >
                                                <Button2
                                                    redirect={card.redirect}
                                                    label={card.btnTitle}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </Grid2>
                                <Grid2
                                    size={{ xs: 12, md: 6 }}
                                    style={{ display: 'flex', justifyContent: screenSize > 968 ? (card.imgPosition === 'Left' ? 'flex-end' : 'flex-start') : 'center'}}
                                >
                                    <CardMedia
                                        component="img"
                                        height="140"
                                        image={card.image}
                                        alt={card.title}
                                        className={styles.o_cards_conocer__img}
                                    />
                                </Grid2>
                            </Grid2>
                        </Card>
                    ))}
                </div>
            </Fade>
        </Container>
    );
};

export default cardsConocer;
